<script>
  import { fly } from 'svelte/transition'
</script>

<style lang="scss">
  div {
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      margin-bottom: $GU;
      line-height: 1.5em;

      &:last-of-type {
          margin-bottom: 0;
      }
    }

    hr {
      width: 80%;
      margin: 2 * $GU auto;
      border: none;
      border-top: 1px solid $light-grey;
    }

    img {
      height: 150px;
      margin-top: 2 * $GU;
    }
  }
</style>

<div in:fly={{ y: 200, delay: 300, duration: 300 }} out:fly={{ y: 200, duration: 300 }}>
  <p>
    Free Foucault est une plateforme décentralisée et non-censurable donnant accès à une version restaurée
    des enregistrements - ainsi débarassés de leurs grésillements - des cours dispensés par Michel Foucault au Collège de France entre 1972 et 1984.
  </p>
  <p>
    On s'étonnera peut-être qu'il ait fallu attendre 50 ans pour que les enregistrements des
    cours de
    <a href="https://fr.wikipedia.org/wiki/Michel_Foucault" target="_blank">
        « l'auteur en sciences humaines le plus cité au monde »
    </a>
    - hier encore réservés aux amis du Collège de France - soient enfin restaurés et rendus à
    l'écoute des nigauds ordinaires. On s'étonnera aussi qu'il ait fallu, pour cela,
    l'intervention d'un pangolin. Ne s'en étonneront en vérité que
    <a href="https://fr.wikiquote.org/wiki/Bureaucratie" target="_blank">
        les fonctionnaires médiocres, nuls, imbéciles, pelliculaires, ridicules, râpés, pauvres, impuissants
    </a>
    de la république.
  </p>
  <hr />
  <p>
    Cette plateforme repose sur la technologie <a href="https://fr.wikipedia.org/wiki/InterPlanetary_File_System" target="_blank">IPFS</a>.
    Chaque enregistrement y est découpé en une multiplicité de petits fragments eux-mêmes éparpillés à travers une multiplicité de serveurs. 
    Cette fragmentation-dispersion de la donnée, rendant inassignable « l'hébergeur » de ces enregistrements, constitue la meilleure défense contre la censure. 
  </p>
  <p>
    Nous pensons aussi que Michel Foucault aurait apprécié le procédé : c’est, après tout, par ce type de dispersion que s'organise <a href="https://vacarme.org/article1388.html" target="_blank">l’art de n’être pas tellement gouverné</a>.
    Sa voix se dupliquera désormais de serveurs en serveurs, de fragments en fragments, <a href="http://1libertaire.free.fr/Foucault64.html" target="_blank">comme une épave heureuse</a>.
    Nous espérons ainsi que cette technologie permettra à la voix de Michel Foucault de vivre éternellement. 
  </p>
  <hr />
  <p>
    Pour des raisons techniques nous publierons un cours par semaine. Actualité oblige, nous inaugurons le lancement de cette plateforme avec la publication de « Naissance de la bio-politique ». 
    Dans ce cours, dispensé entre 1978 et 1979, Michel Foucault analysait « la manière dont on a essayé, depuis le XVIIIe siècle, de rationaliser les problèmes posés à la pratique gouvernementale par les phénomènes propres à un ensemble de vivants constitués en population : santé, hygiène, natalité, longévité, races… »
  </p>
  <hr />
  <p>
    Vous pouvez nous suivre et nous insulter sur twitter à <a href="https://twitter.com/LEcrevisses" target="_blank">@LEcrevisses</a> et nous envoyer vos mots d'amour
    à <a href="mailto:lesecrevisses@protonmail.com">lesecrevisses [at] protonmail [dot] com</a>.
    Si vous avez trop d'argent vous pouvez décharger votre excédent de bitcoin à l'addresse bc1qlr02wyeeuqxwtgahqjcmjh9qtr03n7dd56nz4e.
  </p>
  <hr />
  <p>
    Nous avançons latéralement. Nous sommes les écrevisses.
  </p>
  <img src="./img/ecrevisse.png" alt="Les Écrevisses" />
</div>
